import React from 'react';
import { shape, string, object } from 'prop-types';
import { Link } from 'gatsby';

import SafeGatsbyImage from '../SafeGatsbyImage';

const Footer = ({ data }) => {
  const { title, baseline, shortCurriculum, gpsLatitude, gpsLongitude, staticMap } = data;

  return (
    <footer className="footer hierarchy">
      <div className="container">
        <div className="row">
          <div className="col-md-10">
            <div className="col ordre_general">
              <h2>{title}</h2>
              <div className="subtitle">{baseline}</div>
              <p itemProp="description">{shortCurriculum}</p>
            </div>
          </div>

          <div className="col-md-2">
            <div className="col">
              {gpsLatitude && gpsLongitude && (
                <a
                  href={staticMap.mapUrl}
                  itemProp="hasMap"
                  title={`Google Maps for ${title}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <SafeGatsbyImage image={staticMap} />
                </a>
              )}
            </div>
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-lg-9 copyright">
            <Link to="/copyright/">©&nbsp;</Link>
            <span style={{ marginRight: '10px' }}>{title}</span>
            <Link to="/">Accueil</Link>&nbsp;|&nbsp;
            <Link to="/nous-contacter/">Nous contacter</Link>&nbsp;|&nbsp;
            <Link to="/mentions-legales/">Mentions légales</Link>
          </div>
          <div className="col-lg-3 footer-logo"></div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  data: shape({
    title: string,
    baseline: string,
    shortCurriculum: string,
    gpsLatitude: string,
    gpsLongitude: string,
    staticMap: object,
  }),
};

Footer.defaultProps = {
  data: {
    title: '',
    baseline: '',
    shortCurriculum: '',
    gpsLatitude: undefined,
    gpsLongitude: undefined,
    staticMap: {},
  },
};

export default Footer;
